export const paymentErrors = {
  generic: 'Something went wrong. Please try again.',
  notProcessed: 'Payment not processed.',
}
